import { render, staticRenderFns } from "./PdfModal.vue?vue&type=template&id=66dd0677"
import script from "./PdfModal.vue?vue&type=script&lang=js"
export * from "./PdfModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports